const initialBrand = {
  brands : [],
  brandmessages:{}
};

const BrandReducer = (brand = initialBrand, action) => {
  switch (action.type) {
      case 'GET_BRAND':
        return {
          ...brand, brands: action.payload.data
      };
      case 'ADD_BRAND':
        return {
          ...brand, brandmessages: action.payload.data
      };
      case 'UPDATE_BRAND':
        return {
          ...brand, brandmessages: action.payload.data
      };
      
        default:
          return brand;
  }
}
export default BrandReducer;